import Service from "../Service";
//import AccountService from "./AccountService";

//import assessment from '../../assessment.json';

//const account = new AccountService();
const service = new Service();
const service2 = new Service(null, null, 'apiPathV2');

export default class AssessmentService{
    static GetAssessmentByPatientId(id){
        return service.request('assessment/patient/' + id);
    }

    static GetAssessmentReport(id){
        //return Promise.resolve(parseAssessments(assessment));
        return service.request('ClientReports/' + id).then((json) => {
            return parseAssessments(json);
        })
    }

    static GetAssessment(id){
        return service.request('assessment/' + id);
    }

    static GetAssessmentV3(id){
        return service2.request('Assessments/v1/' + id);
    }

}

const depths = ['section2', 'section3', 'group'];

function parseDepth(data, depth, global){
    let d = depth || 0;
    let depthName = data[depths[d]];
 
    if(d >= depths.length){
        global.push({caption:data.question, value:data.value});
        return;
    }      

    if(global[depthName] === undefined && depthName){
        global[depthName] = (depth == depths.length - 1)? []:{};
    }

    parseDepth(data, ++d, (depthName)? global[depthName]:global);    
}

function parseAnswers(answers){
    let list = {};
    /*answers = answers.sort((a, b) => {
        if(a.index === b.index)return 0;
        return (a.index > b.index)? 1:-1;
    })*/
    for(let i=0; i < answers.length; i++){
        let answer = answers[i];
        parseDepth(answer, 0, list);
    }

    return list;
}

function parseAssessments(assessments){
    let reports = {};
    for(let i=0; i < assessments.length; i++){
        let assessment = assessments[i];
        reports[assessment.section] = parseAnswers(assessment.answers);
    }

    return reports;
}




// WEBPACK FOOTER //
// ./src/api/services/AssessmentService.js